module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_9016.cd31120f.png";